function tooltips() {
  if (iOS()) {
    $(".cpb-option").each((i, option) => {
      if (option.classList.contains('cpb-option-type-text')) return
      const optionId = option.dataset.optionId;

      let optionPrice, optionLabel;

      CPB.getStore()
        .getState()
        .Product.panels.find((panel) =>
          panel.categories.find((category) =>
            category.options.find((option) => {
              if (option.id === optionId) {
                optionPrice = option.price == 0 ? '' : ' ' + Shopify.formatMoney(option.price);
                optionLabel = option.option.data.label;
              }
            })
          )
        );

      tippy(option, {
        content: optionLabel + optionPrice,
        trigger: "click",
        zIndex: 10,
        placement: "bottom",
        flipOnUpdate: true,
        boundary: "window",
      });
    });
  }

  function iOS() {
    var iDevices = [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }
}

// document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', tooltips);
document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
  setTimeout(tooltips, 100);
})
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', tooltips);